import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { Digital } from "react-activity";
import "react-activity/dist/library.css";

export default function Contact() {
   const [values, setValues] = useState({
      name: "",
      email: "",
      message: "",
   });
   const [isLoading, setIsLoading] = useState(false);
   const [successMessage, setSuccessMessage] = useState("");

   const handleChanges = (e) => {
      setValues((values) => ({
         ...values,
         [e.target.name]: e.target.value,
      }));
   };

   const sendMail = (e) => {
      e.preventDefault();
      setIsLoading(true);
      emailjs
         .send(
            "service_n9g7req",
            "template_iosm3xc",
            values,
            "l5qdzhIwXJLMAuj-C"
         )
         .then(
            (response) => {
               if (response.status === 200) {
                  setValues({
                     name: "",
                     email: "",
                     message: "",
                  });
                  setIsLoading(false);
                  setSuccessMessage(
                     "Message sent successfully, thanks for your message."
                  );
               }
            },
            (error) => {
               setIsLoading(false);
               console.log(error);
            }
         );
   };

   return (
      <div>
         <div id="contactContainer">
            <div className="container mt-5">
               <div className="row">
                  <div className="col-md-6 col-sm-12">
                     <form onSubmit={sendMail}>
                        {successMessage && (
                           <div className="alert alert-success mt-2">
                              {successMessage}
                           </div>
                        )}
                        <div className="form-group">
                           <label>Name</label>
                           <input
                              type="text"
                              className="form-control input"
                              name="name"
                              onChange={handleChanges}
                              value={values.name}
                              required
                           />
                        </div>

                        <div className="form-group">
                           <label>Email</label>
                           <input
                              type="email"
                              onChange={handleChanges}
                              className="form-control input"
                              name="email"
                              value={values.email}
                              required
                           />
                        </div>

                        <div className="form-group">
                           <label>Message</label>
                           <br />
                           <textarea
                              name="message"
                              className="form-control input"
                              rows={5}
                              onChange={handleChanges}
                              style={{ resize: "none" }}
                              required
                              value={values.message}
                           ></textarea>
                        </div>

                        {isLoading ? (
                           <button
                              type="button"
                              className="btn btn-lg pull-right send disabled"
                              style={{
                                 color: "pink",
                                 backgroundColor: "rgba(50, 54, 57, 0.6)",
                              }}
                           >
                              <Digital />
                           </button>
                        ) : (
                           <input
                              type="submit"
                              value="SEND"
                              className="btn pull-right send"
                           />
                        )}
                     </form>
                  </div>

                  <div className="col-md-5 col-sm-12 ml-3">
                     <h5>
                        <b>
                           <span style={{ color: "pink" }}>
                              CONTACT DETAILS
                           </span>{" "}
                        </b>
                     </h5>
                     <br />
                     <p>
                        <i
                           className="fa fa-phone mr-2"
                           style={{ color: "pink" }}
                        ></i>
                        +234 903 030 6779
                     </p>
                     <p>
                        <i
                           className="fa fa-envelope mr-2"
                           style={{ color: "pink" }}
                        ></i>
                        coolheaded79@gmail.com
                     </p>
                     <p>
                        <i
                           className="fa fa-map-marker mr-2"
                           style={{ color: "pink" }}
                        ></i>
                        Lagos, Nigeria
                     </p>
                     {/* <div className="first_div">
                <div className="second_div"></div>
              </div> */}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
